import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Typography } from '@mui/material';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PropTypes from 'prop-types';
import { uploadFile } from '../../api/apis';

// const ClassicEditor = require('@ckeditor/ckeditor5-editor-classic');

const CKEditorField = ({ label, defaultValue = '', onChange }) => {
	function uploadAdapter(loader) {
		return {
			upload: () =>
				new Promise((resolve, reject) => {
					const body = new FormData();
					loader.file.then((file) => {
						body.append('image', file);
						uploadFile(body).then(
							(res) => {
								resolve({ default: res.url });
							},
							(err) => {
								reject(err);
							},
						);
					});
				}),
		};
	}
	function uploadPlugin(editor) {
		// eslint-disable-next-line no-param-reassign
		editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
			uploadAdapter(loader);
	}
	return (
		<div className="App">
			<Typography>{label}</Typography>
			<CKEditor
				config={{
					extraPlugins: [uploadPlugin],
				}}
				// editor={ClassicEditor}
				data={defaultValue}
				onReady={() => {
					// You can store the "editor" and use when it is needed.
					// console.log('Editor is ready to use!', editor);
				}}
				onChange={() => {
					// const data = editor.getData();
					// console.log({ event, editor, data });
				}}
				onBlur={(_event, editor) => {
					// console.log('Blur.', editor);
					const data = editor.getData();
					// console.log('Blur.', { event, editor, data });
					onChange(data);
				}}
				onFocus={() => {
					// console.log('Focus.', event, editor);
				}}
			/>
		</div>
	);
};

CKEditorField.propTypes = {
	label: PropTypes.string.isRequired,
	defaultValue: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default CKEditorField;
